export default "__VITE_ASSET__CpkZ4yUk__"